module.exports = __webpack_public_path__ + "img/shareLocation.c6573f8a.svg";